import { Extra } from "@/components/ReservationOptions/Extra/Extra.tsx";
import { VehicleNote } from "@/components/ReservationOptions/VehicleNote/VehicleNote.tsx";
import { useGetOptions } from "@/components/ReservationOptions/hooks/useGetOptions.ts";
import { useGetRGTranslated } from "@/helpers/translation/useGetRGTranslated.ts";
import { useGetRPTranslated } from "@/helpers/translation/useGetRPTranslated.ts";
import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";
import { useTranslation } from "react-i18next";

export const ReservationAccommodationExtras = ({ item }: { item: CartAccommodationItem }) => {
  const { t } = useTranslation();
  const { optionalExtras, mandatoryExtras } = useGetOptions(item);
  const { name: RGName } = useGetRGTranslated(item.ratePlan.rateGroup);
  const { name: RPName } = useGetRPTranslated(item.ratePlan);

  return (
    <div className="reservationAccommodationExtras c-reservation-options__extras">
      <h4 className={"u-h6 u-fw-600"}>{`${RGName} - ${RPName}`}</h4>
      <ul>
        {optionalExtras?.map((optionalExtra) => (
          <Extra key={optionalExtra.id} extra={optionalExtra} cartItem={item} />
        ))}
        <VehicleNote cartItem={item} />
      </ul>
      {mandatoryExtras.length > 0 && (
        <div className="mandatoryExtrasWrap c-reservation-options__mandatory-extras">
          <p className="u-p0 u-fw-600 u-text-dark">{t("mandatoryExtras")}</p>
          {mandatoryExtras?.map((mandatoryExtra) => (
            <Extra key={mandatoryExtra.id} extra={mandatoryExtra} disabled cartItem={item} />
          ))}
        </div>
      )}
    </div>
  );
};
